import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import styles from './MileageAnalysisTab_bus.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { useVehicleData } from './context';


const VehicleHealthCard = ({ selectedVehicleData, globalFilter, customFilter, benchmarkType }) => {
  // const vehicleData = vehicleData?.vehicleHealth || {
  //   coolantlow: { primaryVehicle: '', bestVehicle: '' },
  //   evfaultindication: { primaryVehicle: '', bestVehicle: '' },
  //   highTempIndication: { primaryVehicle: '', bestVehicle: '' },
  //   lowSoCWarning: { primaryVehicle: '', bestVehicle: '' },
  //   checkEngineLamp: { primaryVehicle: '', bestVehicle: '' },
  //   waterInFuelIndicator: { primaryVehicle: '', bestVehicle: '' }
  // };

  const { firstVinNo, secondVinNo } = selectedVehicleData
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { GlobalData, setGlobalData } = useVehicleData();


  const [vehicleData, setVehicleData] = useState({
    coolantlow: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, depotVehicle: null, },
    evfaultindication: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, depotVehicle: null, },
    highTempIndication: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, depotVehicle: null, },
    lowSoCWarning: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, depotVehicle: null, },
    waterInFuelIndicator: { primaryVehicle: null, bestVehicle: null, secondaryVehicle: null, nationalVehicle: null, depotVehicle: null, },
  })


  useEffect(() => {
    setGlobalData(prev => ({ ...prev, vehicleHealthParameter: vehicleData }))
  }, [vehicleData])


  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/mileage_analysis_vehicle_health_parameter`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res

        setVehicleData(prevState => ({
          ...prevState,
          coolantlow: { ...prevState.coolantlow, primaryVehicle: data?.CoolantLow?.toFixed(2) ?? null },
          evfaultindication: { ...prevState.evfaultindication, primaryVehicle: data?.EVFaultIndication?.toFixed(2) ?? null },
          highTempIndication: { ...prevState.highTempIndication, primaryVehicle: data?.HighTemperatureIndication?.toFixed(2) ?? null },
          lowSoCWarning: { ...prevState.lowSoCWarning, primaryVehicle: data?.LowSoCWarning?.toFixed(2) ?? null },
          waterInFuelIndicator: { ...prevState.waterInFuelIndicator, primaryVehicle: data?.ServiceIndication?.toFixed(2) ?? null },
        }));

      }
    );
  }, [firstVinNo.vehicleId, globalFilter])

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/mileage_analysis_best_vehicle_health_parameter`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [firstVinNo.vehicleId],
          }
        }
      },
      (res) => {
        const data = res

        setVehicleData(prevState => ({
          ...prevState, // Keep existing bestVehicle and secondaryVehicle data
          coolantlow: { ...prevState.coolantlow, bestVehicle: data?.CoolantLow?.toFixed(2) ?? null },
          evfaultindication: { ...prevState.evfaultindication, bestVehicle: data?.EVFaultIndication?.toFixed(2) ?? null },
          highTempIndication: { ...prevState.highTempIndication, bestVehicle: data?.HighTemperatureIndication?.toFixed(2) ?? null },
          lowSoCWarning: { ...prevState.lowSoCWarning, bestVehicle: data?.LowSoCWarning?.toFixed(2) ?? null },
          waterInFuelIndicator: { ...prevState.waterInFuelIndicator, bestVehicle: data?.ServiceIndication?.toFixed(2) ?? null },
        }));

      }
    );
  }, [firstVinNo.vehicleId, globalFilter])

  useEffect(() => {
    let vehicleHealthAPiCustom = "mileage_analysis_vehicle_health_parameter"
    let vehicleHealthAPiDepot = "mileage_analysis_depo_vehicle_health_parameter"
    let vehicleHealthAPiNational = "mileage_analysis_national_vehicle_health_parameter"

    setVehicleData(prevState => ({
      ...prevState,
      coolantlow: { ...prevState.coolantlow, secondaryVehicle: null },
      evfaultindication: { ...prevState.evfaultindication, secondaryVehicle: null },
      highTempIndication: { ...prevState.highTempIndication, secondaryVehicle: null },
      lowSoCWarning: { ...prevState.lowSoCWarning, secondaryVehicle: null },
      waterInFuelIndicator: { ...prevState.waterInFuelIndicator, secondaryVehicle: null },
    }));

    //custom
    if (secondVinNo?.vehicleId) {
      fetchData(
        {
          url: API_URL_MAIN + `mileage_analysis/${vehicleHealthAPiCustom}`,
          body: {
            filterdata: {
              ...customFilter,
              "VIN_NUM": [secondVinNo?.vehicleId],
            }
          }
        },
        (res) => {
          const data = res

          setVehicleData(prevState => ({
            ...prevState,
            coolantlow: { ...prevState.coolantlow, secondaryVehicle: data?.CoolantLow?.toFixed(2) ?? null },
            evfaultindication: { ...prevState.evfaultindication, secondaryVehicle: data?.EVFaultIndication?.toFixed(2) ?? null },
            highTempIndication: { ...prevState.highTempIndication, secondaryVehicle: data?.HighTemperatureIndication?.toFixed(2) ?? null },
            lowSoCWarning: { ...prevState.lowSoCWarning, secondaryVehicle: data?.LowSoCWarning?.toFixed(2) ?? null },
            waterInFuelIndicator: { ...prevState.waterInFuelIndicator, secondaryVehicle: data?.ServiceIndication?.toFixed(2) ?? null }, // Assuming 0 for no harsh accelerations
          }));

        }
      )
    }

    // depot
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${vehicleHealthAPiDepot}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res

        setVehicleData(prevState => ({
          ...prevState,
          coolantlow: { ...prevState.coolantlow, depotVehicle: data?.CoolantLow?.toFixed(2) ?? null },
          evfaultindication: { ...prevState.evfaultindication, depotVehicle: data?.EVFaultIndication?.toFixed(2) ?? null },
          highTempIndication: { ...prevState.highTempIndication, depotVehicle: data?.HighTemperatureIndication?.toFixed(2) ?? null },
          lowSoCWarning: { ...prevState.lowSoCWarning, depotVehicle: data?.LowSoCWarning?.toFixed(2) ?? null },
          waterInFuelIndicator: { ...prevState.waterInFuelIndicator, depotVehicle: data?.ServiceIndication?.toFixed(2) ?? null }, // Assuming 0 for no harsh accelerations
        }));

      }
    )


    // national
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis/${vehicleHealthAPiNational}`,
        body: {
          filterdata: {
            ...globalFilter,
            "VIN_NUM": [],
          }
        }
      },
      (res) => {
        const data = res

        setVehicleData(prevState => ({
          ...prevState,
          coolantlow: { ...prevState.coolantlow, nationalVehicle: data?.CoolantLow?.toFixed(2) ?? null },
          evfaultindication: { ...prevState.evfaultindication, nationalVehicle: data?.EVFaultIndication?.toFixed(2) ?? null },
          highTempIndication: { ...prevState.highTempIndication, nationalVehicle: data?.HighTemperatureIndication?.toFixed(2) ?? null },
          lowSoCWarning: { ...prevState.lowSoCWarning, nationalVehicle: data?.LowSoCWarning?.toFixed(2) ?? null },
          waterInFuelIndicator: { ...prevState.waterInFuelIndicator, nationalVehicle: data?.ServiceIndication?.toFixed(2) ?? null }, // Assuming 0 for no harsh accelerations
        }));
      }
    )
      ;
  }, [secondVinNo?.vehicleId, customFilter, globalFilter, benchmarkType])

  const currentHistoryTabs = [
    {
      key: 'coolantlow',
      name: 'Coolant Low',
      unit: '%'
    },
    {
      key: 'evfaultindication',
      name: 'EV Fault Indication',
      unit: '%'
    },
    {
      key: 'highTempIndication',
      name: 'High Temperature Indication',
      unit: '%'
    },
    {
      key: 'lowSoCWarning',
      name: 'Low SoC Warning',
      unit: '%'
    },
    {
      key: 'waterInFuelIndicator',
      name: 'Service Indication',
      unit: '%'
    }
  ]


  return (
    <div className="mb-4">
      <div className="d-flex align-items-center mb-3">
        <h6 className={styles.cardTitle}>
          Vehicle Health Parameter :
        </h6>
      </div>

      <div className={styles.containerBackground}>
        {/* Distance Row */}
        {
          currentHistoryTabs.map((item, index) =>
            <div className="row mb-2" key={index}>
              <div className="col-3">
                <div className={`p-2 d-flex align-items-center ${styles.labelContainer}`}>
                  <span className={styles.labelText}>{item.name}</span>
                </div>
              </div>
              <div className="col-3">
                <div className={`p-2 d-flex justify-content-center align-items-center ${styles.valueContainer}`}>
                  <span className={styles.valueText}>
                    {vehicleData?.[item.key]?.primaryVehicle !== null ? <> {vehicleData?.[item.key]?.primaryVehicle}{" " + item.unit}</> : <>--</>}
                  </span>
                </div>
              </div>
              <div className="col-3">
                <div className={`p-2 d-flex justify-content-center align-items-center ${styles.valueContainer}`}>
                  <span className={styles.valueText}>
                    {vehicleData?.[item.key]?.bestVehicle !== null ? <> {vehicleData?.[item.key]?.bestVehicle}{" " + item.unit}</> : <>--</>}
                  </span>
                </div>
              </div>
              <div className="col-3">
                <div className={`p-2 d-flex justify-content-center align-items-center ${styles.valueContainer}`}>
                  {/* <span className={styles.valueText}>
                    {vehicleData?.[item.key]?.secondaryVehicle !== null ? <> {vehicleData?.[item.key]?.secondaryVehicle}{" " + item.unit}</> : <>{secondVinNo?.vehicleId ? <>--</> : ""}</>}
                  </span> */}
                  {
                    benchmarkType == "Custom" ?
                      <span className={styles.dataValue}>
                        {vehicleData?.[item.key]?.secondaryVehicle ? <>{vehicleData?.[item.key]?.secondaryVehicle}{" " + item.unit}</> : <>{secondVinNo?.vehicleId ? <>--</> : ""}</>}
                      </span> :
                      benchmarkType == "National" ?
                        <span className={styles.dataValue}>
                          {vehicleData?.[item.key]?.nationalVehicle ? <>{vehicleData?.[item.key]?.nationalVehicle}{" " + item.unit}</> : <>--</>}
                        </span> :
                        <span className={styles.dataValue}>
                          {vehicleData?.[item.key]?.depotVehicle ? <>{vehicleData?.[item.key]?.depotVehicle}{" " + item.unit}</> : <>--</>}
                        </span>
                  }
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default VehicleHealthCard;
